import React from "react";
import styles from "./IlomeModal.module.scss";

import { IlomeContainer } from "../../../../ceremony/ilome/IlomeContainer";

const IlomeModalView = ({
    isVisible,
    hideModal,
    ilomeName,
    ilomeEmail,
    ceremonyId,
    onSuccesfullUpdate,
}) => {
    return (
        <>
            <div
                className={`modal ${styles.modal} ${
                    isVisible ? "is-active" : ""
                }`}
            >
                <div className="modal-background" />
                <div className={`modal-card ${styles.modalCard}`}>
                    <IlomeContainer
                        hideModal={hideModal}
                        isVisible={isVisible}
                        ilomeName={ilomeName}
                        ilomeEmail={ilomeEmail}
                        ceremonyId={ceremonyId}
                        onSuccessfulUpdate={onSuccesfullUpdate}
                    />
                </div>
            </div>
        </>
    );
};

export default IlomeModalView;
